import { ReportColumn } from "@/types/evaluate";
import React from "react";

interface DatasetColumnCellProps {
  column: ReportColumn;
}

export const DatasetColumnCell: React.FC<DatasetColumnCellProps> = ({
  column,
}) => (
  <div className="flex h-full w-full flex-row items-center justify-center">
    <div className="text-center font-mono">{`{${column.name}}`}</div>
  </div>
);
